/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const ImportStockStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  import: {
    name: 'อัพโหลด CSV',
    color: 'info',
    icon: 'task_alt',
  },
  read: {
    name: 'อ่านไฟล์ CSV',
    color: 'info',
    icon: 'task_alt',
  },
  compile: {
    name: 'ประมวลผล',
    color: 'info',
    icon: 'task_alt',
  },
  success: {
    name: 'เสร็จสิ้น',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default ImportStockStatus;
